const css = `._tabs_1gaay_1 {
  background-color: var(--bg-color);
}
._tabsButtons_1gaay_4, ._tabsDropdown_1gaay_4 {
  position: relative;
  background-color: var(--bg-color);
  overflow-y: auto;
  position: sticky;
  top: 50px;
  z-index: 1;
}
._tabsButtons_1gaay_4::after, ._tabsDropdown_1gaay_4::after {
  background-color: var(--border-color);
  bottom: 0;
  content: "";
  display: block;
  height: 1px;
  left: 0;
  position: absolute;
  width: 100%;
}
._tabsDropdown_1gaay_4 {
  margin-top: -16px;
  padding: 16px 0;
}
._tabsButton_1gaay_4 {
  position: relative;
  border: 0 none transparent;
  z-index: 1;
}
._tabsButton_1gaay_4::after {
  background-color: var(--border-color);
  bottom: 0;
  content: "";
  display: block;
  height: 1px;
  left: 0;
  position: absolute;
  width: 100%;
}
._tabsButton_1gaay_4:not(:hover) {
  background-color: transparent;
}
._tabsButton_1gaay_4:not(._tabsButtonActive_1gaay_44):not(:hover) {
  color: var(--secondary-text-color);
}
._tabsButtonActive_1gaay_44 {
  position: relative;
}
._tabsButtonActive_1gaay_44::after {
  background-color: var(--secondary-border-color);
  bottom: 0;
  content: "";
  display: block;
  height: 1px;
  left: 0;
  position: absolute;
  width: 100%;
}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
export default {
  "tabs": "_tabs_1gaay_1",
  "tabsButtons": "_tabsButtons_1gaay_4",
  "tabsDropdown": "_tabsDropdown_1gaay_4",
  "tabsButton": "_tabsButton_1gaay_4",
  "tabsButtonActive": "_tabsButtonActive_1gaay_44"
};